export type IcProtectiveMarkings =
  | "default"
  | "official"
  | "official-sensitive"
  | "secret"
  | "top-secret";
